import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OngoingInpatientVisitsQueryVariables = Types.Exact<{
  input: Types.OngoingInpatientVisitsInput;
}>;


export type OngoingInpatientVisitsQuery = { readonly __typename?: 'Query', readonly ongoingInpatientVisits?: { readonly __typename?: 'PaginatedVisits', readonly items: ReadonlyArray<{ readonly __typename?: 'Visit', readonly _id: string } | null> } | null };


export const OngoingInpatientVisitsDocument = gql`
    query OngoingInpatientVisits($input: OngoingInpatientVisitsInput!) {
  ongoingInpatientVisits(input: $input) {
    items {
      _id
    }
  }
}
    `;

/**
 * __useOngoingInpatientVisitsQuery__
 *
 * To run a query within a React component, call `useOngoingInpatientVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOngoingInpatientVisitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOngoingInpatientVisitsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOngoingInpatientVisitsQuery(baseOptions: Apollo.QueryHookOptions<OngoingInpatientVisitsQuery, OngoingInpatientVisitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OngoingInpatientVisitsQuery, OngoingInpatientVisitsQueryVariables>(OngoingInpatientVisitsDocument, options);
      }
export function useOngoingInpatientVisitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OngoingInpatientVisitsQuery, OngoingInpatientVisitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OngoingInpatientVisitsQuery, OngoingInpatientVisitsQueryVariables>(OngoingInpatientVisitsDocument, options);
        }
export type OngoingInpatientVisitsQueryHookResult = ReturnType<typeof useOngoingInpatientVisitsQuery>;
export type OngoingInpatientVisitsLazyQueryHookResult = ReturnType<typeof useOngoingInpatientVisitsLazyQuery>;
export type OngoingInpatientVisitsQueryResult = Apollo.QueryResult<OngoingInpatientVisitsQuery, OngoingInpatientVisitsQueryVariables>;